import { BaseAction } from "../../../core/actions/BaseAction";
import { getRuntimeConfig } from "../../../Lib/Config/RuntimeConfig";
import { IGetOSInfoParams } from "../../../Orchestrator/Types/Interface/IGetAppBanner";
import { getAppDownloadLinkAction } from "../../LogicActions/Search/GetAppDownloadLinkAction";
import { getCmsAppDownloadLinksAndQrAction } from "../../LogicActions/Search/GetCmsAppDownloadLinksAndQrAction";

class GetOROpenAppAction extends BaseAction<void, IGetOSInfoParams> {
  override async run(): Promise<void> {
    try {
        const config = await getRuntimeConfig();
      const { osInfo } = this.params!;

      await getAppDownloadLinkAction.execute();
      if (!getAppDownloadLinkAction?.result) {
        return;
      }

      const fallbackIOS = getAppDownloadLinkAction?.result?.appStoreLink
      const fallbackAndroid = getAppDownloadLinkAction?.result?.playStoreLink

      if (osInfo === "Android") {
        // const now = new Date().getTime();

        // const timeout = setTimeout(() => {
        //   const elapsed = new Date().getTime() - now;
        //   if (elapsed < 1500) {
        //     window.location.href = fallbackAndroid;
        //   }
        // }, 1000);
        window.location.href = fallbackAndroid;

        // window.location.href = appIntentAndroid;
      } else if (osInfo === "iOS") {
        // const now = new Date().getTime();

        // const timeout = setTimeout(() => {
        //   const elapsed = new Date().getTime() - now;
        //   if (elapsed < 1500) {
        //     window.location.href = fallbackIOS;
        //   }
        // }, 1000);

        window.location.href = fallbackIOS;
        // window.location.href = appIntentIOS;
      } else {
        console.warn("Unsupported OS: App cannot be opened.");
      }
    } catch (error: any) {
      console.error("Error detecting OS or opening app:", error);
    }
  }
}

export const getOROpenAppAction = new GetOROpenAppAction();
